export type TLogAction = {
  type: "log";
  title: string;
  text: string;
};

export const defaultLogAction: TLogAction = {
  type: "log",
  title: "INFO",
  text: "a message",
};

export type TLevel = "info" | "warning" | "error";

export type TNotifyAction = {
  type: "notify";
  title: string;
  text: string;
  level: TLevel;
};

export const defaultNotifyAction: TNotifyAction = {
  type: "notify",
  title: "a title",
  text: "a message",
  level: "info",
};

export type TMqttAction = {
  type: "mqtt";
  control_id?: number;
  command?: string;
  parameter?: string;
};

export const defaultMqttAction: TMqttAction = {
  type: "mqtt",
};
